import axios from 'axios'
import { useEffect, useState } from 'react'
import authService from '../../../Components/Login/auth.service'
//const uuidv4 = require('uuid/v4')

export default function Modal() {
  const uuidv4 = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(16) + '-' + Math.random().toString(16).slice(2);
  var user = authService.getCurrentUser()
  const [modal, setModal] = useState(false)
  const [documentoForm, setDocumentoForm] = useState('')
  const [tipoDocumentos, setTipoDocumentos] = useState([])
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
        '/api/v1/tipodocumento/list/' +
        user[0].IdEmpresa
      )
      .then(response => {
        setTipoDocumentos(response.data)
      })
  }, [])

  const toggleModal = () => {
    setModal(!modal)
  }

  if (modal) {
    document.body.classList.add('active-modal')
  } else {
    document.body.classList.remove('active-modal')
  }
  let newDate = new Date()

  const [campos, setCampos] = useState({
    IdDocumentoCliente: 0,
    IdTipoDocumento: 0,
    IdEmpresa: user[0].IdEmpresa,
    IdUnidade: sessionStorage.IdUnidade,
    IdLocal: sessionStorage.IdLocal,
    dccUrl: '',
    dccValidade: '',
    dccStatus: 1,
    dccObservacoes: '',
    dccCriadoPor: user[0].pesEmail,
    dccCriadoEm: newDate,
    dccAlteradoPor: user[0].pesEmail,
    dccAlteradoEm: newDate,
    dccCodigoGUID: uuidv4
  })
  function handleInputChange(event) {
    if (event.target.name === 'dccStatus') {
      if (event.target.checked) {
        campos[event.target.name] = 1
      } else {
        campos[event.target.name] = 0
      }
    } else {
      campos[event.target.name] = event.target.value
    }
    setCampos(campos)
  }
  const [documentos, setDocumentos] = useState({
    NomeArquivo: '',
    Arquivo: ''
  })
  function handleFormSubmit(event) {
    event.preventDefault()
    const formData = new FormData()
    formData.append('file', documentoForm)
    event.preventDefault()
    var reader = new FileReader()
    reader.readAsDataURL(documentoForm)
    reader.onload = function (fileLoadedEvent) {
      var srcData = fileLoadedEvent.target.result
      documentos['Arquivo'] = srcData.split(',')[1]
      documentos['NomeArquivo'] = documentoForm.name.replace(/ /g, '-')
      setDocumentos(documentos)
      console.log(documentos)
      axios
        .post(process.env.REACT_APP_API_URL + '/uploadDocumento', formData)
        .then(response => {
          campos['dccUrl'] = response.data.url
          setCampos(campos)
          console.log(campos)
          axios
            .post(
              process.env.REACT_APP_API_URL + '/api/v1/documentocliente',
              campos
            )
            .then(response => {
              console.log(campos)
              alert(response.data.message)
              window.location.reload()
            })
        })
    }
  }
  return (
    <>
      <button onClick={toggleModal} className="buttonModalPadraoPes">
        Novo Documento
      </button>

      {modal && (
        <>
          <div onClick={toggleModal} className="overlay"></div>
          <div className="modalPadrao-content">
            <div className="cxTituloPadrao">
              <h1>
                Novo Documento
                <hr className="hrTitleModal" />
              </h1>
              <button onClick={toggleModal}>X</button>
            </div>

            <form onSubmit={handleFormSubmit}>
              <label>Selecione um tipo de Documento:</label>
              <select
                name="IdTipoDocumento"
                type="text"
                defaultValue={campos.IdTipoDocumento}
                id="fSexo"
                onChange={handleInputChange}
              >
                <option value="0">Selecione um tipo de Documento</option>
                {tipoDocumentos.map(tipoDocumento => (
                  <option value={tipoDocumento.IdTipoDocumento}>
                    {tipoDocumento.tpdDescricao}
                  </option>
                ))}
              </select>
              <div className="lineModal">
                <label>Selecione um documento:</label>

                <input
                  type="file"
                  name="dccUrl"
                  id="dccUrl"
                  className="modalInputDoc"
                  required
                  accept=".gif,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.pdf,.txt"
                  onChange={function (event) {
                    setDocumentoForm(event.target.files[0])
                  }}
                />
              </div>
              <div className="lineModal">
                <label>Validade:</label>
                <input
                  placeholder="__/__/____"
                  type="date"
                  id="dccValidade"
                  defaultValue={campos.dccValidade}
                  name="dccValidade"
                  onChange={handleInputChange}
                  step=".01"
                  min={0}
                ></input>
              </div>

              <label>Observações:</label>
              <textarea
                type="text"
                id="fname"
                name="dccObservacoes"
                defaultValue={campos.dccObservacoes}
                row="none"
                onChange={handleInputChange}
                maxLength="500"
              ></textarea>

              <div className="caixaSalvarPadrao">
                <div className="InputAuthorization4">
                  <label>
                    <input
                      name="dccStatus"
                      type="checkbox"
                      defaultChecked={!!campos.dccStatus}
                      onChange={handleInputChange}
                    />
                    <span>Status</span>
                  </label>
                </div>

                <button type="submit">Salvar Registro</button>
              </div>
            </form>
          </div>
        </>
      )}
    </>
  )
}
